{
  "VALIDATION_FAILED": "The submitted data is not valid",
  "UNAUTHENTICATED": "You need to sign in",
  "INVALID_CREDENTIALS": "Invalid email or password",
  "TOKEN_EXPIRED": "Your session expired",
  "TOKEN_REVOKED": "This session was revoked",
  "NO_PLATFORM_ACCESS": "You do not have access to this platform",
  "UA_UNAVAILABLE": "Unified Access is temporarily unavailable",
  "FORBIDDEN": "You do not have permission for this action",
  "NOT_FOUND": "The requested item was not found",
  "routeNotFound": "This page does not exist.",
  "CONFLICT": "Conflicting data",
  "UNIQUE_VIOLATION": "This value is already taken",
  "FOREIGN_KEY_VIOLATION": "This record is referenced elsewhere",
  "RATE_LIMITED": "Too many attempts, try again later",
  "IDEMPOTENCY_KEY_REUSED": "This request key was already used for another operation",
  "REQUEST_IN_PROGRESS": "This request is still being processed",
  "PAYLOAD_TOO_LARGE": "The payload is too large",
  "UNPROCESSABLE": "The request could not be processed",
  "INTERNAL_ERROR": "An unexpected error occurred",
  "SERVICE_UNAVAILABLE": "The service is temporarily unavailable",
  "NO_QUANTITY": "Enter a quantity for at least one barrel or jerrycan",
  "NON_POSITIVE_TOTAL": "The total after the jerrycan deduction must be greater than zero",
  "LESS_JERRYCANS_EXCEED_TOTAL": "Less jerrycans is greater than the total jerrycans",
  "REVOLVING_BALANCE_REQUIRED": "Enter the carried balance of this product for the current business date before any other operation",
  "DEBT_LIMIT_EXCEEDED": "Cannot complete the transaction: the amount plus this debtor's current total debt exceeds the debt limit of {{limit}} JOD",
  "VEHICLE_NOT_OF_DEBTOR": "The selected vehicle does not belong to this debtor",
  "WRONG_CLOSE_PASSWORD": "Wrong password",
  "CLOSE_PASSWORD_NOT_SET": "No shift close password is set; contact your administrator",
  "CLOSE_TEMPORARILY_BLOCKED": "Closing is blocked for 15 minutes after repeated wrong passwords",
  "SYSTEM_FROZEN": "The system is temporarily frozen for a year-management operation",
  "ALREADY_DELIVERED": "Delivery was already confirmed",
  "NOT_DELIVERABLE": "This transaction cannot be delivered",
  "MESSAGE_NOT_RETRYABLE": "This message cannot be resent",
  "WRONG_PASSWORD": "Incorrect password",
  "YEAR_PRECONDITION_FAILED": "Complete and verify the backup and the archive migration first",
  "CATEGORY_NOT_AVAILABLE": "The category does not exist",
  "PRODUCT_NOT_ALLOWED": "You do not have access to this product",
  "BRANCH_NOT_ALLOWED": "You do not have access to this branch",
  "SYSTEM_GROUP_PROTECTED": "The system administrator group cannot be deleted or emptied",
  "ARCHIVE_READ_ONLY": "The archive is read-only",
  "network": "Could not reach the server",
  "timeout": "We could not confirm this finished. Check the current state before trying again.",
  "referenceId": "Reference: {{requestId}}",
  "PDA_NET_QUANTITY_NOT_POSITIVE": "The net quantity must be greater than zero",
  "PDA_CATEGORY_MISSING": "A selected quantity option is no longer available; reload and try again",
  "PDA_CUSTOMER_EXISTS": "The customer is already registered",
  "PDA_TRANSACTION_NOT_FOUND": "Transaction not found",
  "PDA_NOT_A_SALE": "This transaction is not a sale",
  "PDA_TRANSACTION_CANCELLED": "The transaction is cancelled",
  "PDA_WHATSAPP_DISABLED": "WhatsApp sending is disabled",
  "FORBIDDEN_PRODUCT": "You do not have access to this product",
  "PURCHASE_ALREADY_PRICED": "This purchase is already priced",
  "NATIONALITY_NAME_EXISTS": "This nationality name is already used",
  "PHONE_TAKEN": "The phone number is already registered to another customer. Please enter a different phone number.",
  "PHONE_CHANGED": "The phone number was changed elsewhere. Reload the page and try again.",
  "CUSTOMERS_UNAVAILABLE": "The Customers system could not be reached to check the phone number, so nothing was saved. Try again.",
  "CUSTOMERS_CUSTOMER_NOT_FOUND": "This customer no longer exists in the Customers system (it may have been deleted), so nothing was saved.",
  "CUSTOMERS_REFUSED": "The Customers system refused the phone change, so nothing was saved. Contact the system administrator.",
  "WRONG_OVERVIEW_PASSWORD": "Wrong password",
  "OVERVIEW_PASSWORD_NOT_SET": "No overview password has been set yet",
  "OVERVIEW_TEMPORARILY_BLOCKED": "Statistics are blocked for 15 minutes after repeated wrong passwords",
  "INVENTORY_MODE_ACTIVE": "Inventory count mode is still on: confirm a forced post",
  "NO_OPEN_SHIFT": "No shift is open: enter the carried balance for the current business date first",
  "ALREADY_POSTED": "This transaction has already been posted",
  "PENDING_NOT_COMPLETED": "Complete the price of the transaction before posting it",
  "INVALID_TRANSACTION_CODE": "Invalid transaction number",
  "TRANSACTION_NOT_FOUND": "Transaction not found",
  "TRANSACTION_CANCELLED": "The transaction is cancelled",
  "WRONG_PRODUCT": "This transaction belongs to the other product, switch the product to continue",
  "NO_ACTION_AVAILABLE": "No action is available for this transaction",
  "SALE_ALREADY_PRICED": "This transaction is already completed",
  "SALE_NOT_COMPLETED": "The sale is not completed yet. Send the customer to the office to complete it",
  "DEBTOR_BRANCH_MISMATCH": "The debtor does not belong to the movement branch",
  "PHONE_REQUIRED": "The phone number is required",
  "PHONE_INVALID": "The phone number is not valid",
  "PHONE_NOT_MOBILE": "Landline numbers are not allowed. Enter a mobile number",
  "PHONE_COUNTRY_NOT_ALLOWED": "Numbers from this country are not accepted",
  "PHONE_VERIFICATION_REQUIRED": "Verify the phone number before saving",
  "PHONE_VERIFICATION_INVALID": "The phone verification expired. Verify again",
  "PHONE_VERIFICATION_RECEIPT_EXPIRED": "The phone verification expired. Verify again",
  "OTP_INVALID": "The code is incorrect. {{attemptsLeft}} attempts left",
  "OTP_EXPIRED": "The code has expired. Request a new code",
  "OTP_ATTEMPTS_EXCEEDED": "Too many wrong attempts. Request a new code",
  "OTP_RESEND_TOO_SOON": "Resend in {{retryAfterSeconds}} seconds",
  "OTP_SEND_LIMIT": "Too many codes were sent to this number. Try again in {{minutes}} minutes",
  "OTP_SEND_FAILED": "The verification code could not be sent by WhatsApp. Nothing was saved. Try again, or an administrator can turn verification off in the settings",
  "OTP_ALREADY_VERIFIED": "The code has expired. Request a new code",
  "OTP_ALREADY_CONSUMED": "The code has expired. Request a new code",
  "OTP_BINDING_MISMATCH": "The code has expired. Request a new code",
  "OTP_NOT_VERIFIED": "The code has expired. Request a new code",
  "OTP_CONSUME_WINDOW_PASSED": "The code has expired. Request a new code",
  "IDEMPOTENCY_CONFLICT": "This request key was already used for another operation",
  "CUSTOMERS_CALL_IN_FLIGHT": "The customer's details are being sent to the Customers system; try again in a moment",
  "PDA_SYNC_PENDING": "The transaction is waiting for synchronisation from the PDA",
  "PDA_GRANT_INVALID": "The offline permission is not valid for this device. Sign in again",
  "PDA_GRANT_EXPIRED": "The offline permission ended more than 7 days ago. Contact the office"
}
